import { matchesPath } from '../matchesPath';

export const matchesDuplicateProject = matchesPath(/\/duplicate-project/);
